import styled from "styled-components";

export const SchoolHubContentStack = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
`;

export const SchoolHubTabRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
`;

export const SchoolHubTabButton = styled.button<{ $active?: boolean }>`
  background: ${({ $active }) =>
    $active ? "var(--brand-highlight)" : "rgba(255, 255, 255, 0.04)"};
  border: 1px solid
    ${({ $active }) => ($active ? "transparent" : "rgba(255, 255, 255, 0.08)")};
  border-radius: 999px;
  box-shadow: none;
  color: ${({ $active }) => ($active ? "#1b1306" : "rgba(245, 239, 230, 0.82)")};
  cursor: pointer;
  font-size: 0.8125rem;
  font-weight: 600;
  padding: 0.4375rem 0.875rem;
  transition:
    background 160ms ease,
    border-color 160ms ease,
    color 160ms ease;

  &:hover {
    background: ${({ $active }) =>
      $active ? "var(--brand-highlight)" : "rgba(120, 167, 222, 0.08)"};
    color: ${({ $active }) => ($active ? "#1b1306" : "var(--brand-ink)")};
  }

  &:focus-visible {
    outline: 2px solid var(--brand-highlight);
    outline-offset: 2px;
  }
`;
